"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.save = save;
var _credentials = require("../credentials");
function credentialsSelector(_ref) {
  var _ref$data = _ref.data,
    login = _ref$data.login,
    refreshToken = _ref$data.refreshToken,
    loginAnonymousUser = _ref$data.loginAnonymousUser;
  return login || refreshToken || loginAnonymousUser;
}

/**
 * Store a logged in user's credentials and selectedOrganisationId, including token in storage.
 * If any of the required fields are missing, we throw an error so
 * the caller can handle it
 *
 * @param {authObject} authObject
 *
 * @return {void}
 */

function save(authObject) {
  var authData = 'data' in authObject ? credentialsSelector(authObject) : authObject;
  (0, _credentials.set)(authData);
}